import "./arboretum.css";
import React from "react";
import useArboretum from "../../../../hooks/corral/arboretum";
import { useCurrentUser } from "../../../../hooks/currentUser";
import QuadrantBubble from "./QuadrantBubble";
import { Loader, Overlay, Container, Text, Title, Center } from "@mantine/core";
import { useNavigate } from "react-router-dom";

const Arboretum = () => {
  const navigate = useNavigate();
  const { currentUser } = useCurrentUser();
  const { arboretum, arboretumRef, dimensions } = useArboretum({
    currentUser,
  });

  if (!arboretum) {
    return (
      <Overlay opacity={0.6} color="#000" zIndex={5}>
        <Loader size="xl" variant="bars" />
      </Overlay>
    );
  }

  return (
    <Container>
      <Center>
        <Title order={3}>
          {currentUser.activeCharacter?.name}'s Planar Arboretum
        </Title>
      </Center>
      <Center>
        {arboretum && (
          <div className="arboretum-card" ref={arboretumRef}>
            {arboretum.quadrants?.map((quadrant) => (
              <QuadrantBubble
                key={quadrant.id}
                dimensions={dimensions}
                graphObj={arboretum}
                onClick={() => navigate(`${quadrant.id}`)}
                {...quadrant}
              />
            ))}
          </div>
        )}
      </Center>
    </Container>
  );
};

export default Arboretum;
